// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dc-logo[data-v-661d67ae]{font-weight:600;font-size:3rem;color:#ff6352;letter-spacing:.075rem}@media only screen and (min-width: 737px){.dc-logo[data-v-661d67ae]{font-size:4.8rem}}.dc-logo span[data-v-661d67ae]{font-weight:300}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
